var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container flex-wrap flex-line"},[_c('div',{ref:"tools",staticClass:"container",staticStyle:{"width":"220px"}}),_c('div',{ref:"client",staticClass:"container",staticStyle:{"flex-grow":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }